export const LOAN_STATUS_LABEL_ALL_ACTIVE = "All Active Loans";
